import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'ssab-cx-not-found',
  templateUrl: './ssab-not-found.component.html',
})
export class SsabNotFoundComponent {

  productPage$: Observable<boolean>;
  coilsPage$: Observable<boolean>;

  constructor(protected activatedRoute: ActivatedRoute) {
    this.productPage$ = this.activatedRoute.url.pipe(
      map((url) => url[0].path === 'product'),
    );
    this.coilsPage$ = this.activatedRoute.url.pipe(
      map((url) => url[0].path === 'coil-comparison'),
    );
  }

}
